import { create } from "zustand";
import { createStoreWithSelectors } from "./createStoreWithSelectors";

interface AreasModalState {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const areasModalStore = create<AreasModalState>()((set) => ({
  isOpen: false,
  onOpen: () => set(() => ({ isOpen: true })),
  onClose: () => set(() => ({ isOpen: false })),
}));

export const useAreasModalStore = createStoreWithSelectors(areasModalStore);
